export const LOAD_ALERT_MESSAGES = '[messages] load alert messages';
export const REFRESH_ALERT_MESSAGES =
  '[messages] refresh recent alert messages';
export const PROCESS_ALERT_MESSAGES = '[messages] process alert messages';
export const LOAD_PROCESSED_ALERT_MESSAGES =
  '[messages] load processed alert messages';
export const MESSAGE_ERROR = '[messages] message error';
export const PROCESS_CANCELLING_MESSAGE =
  '[messages] process cancelling a message';
export const CANCEL_MESSAGE = '[messages] cancel message';
export const LOAD_MESSAGE_DETAILS = '[messages] load message details';
export const PROCESS_MESSAGE_DETAILS = '[messages] process message details';
export const UPDATE_MESSAGE = '[messages] Update message';
export const LOAD_PROCESSED_MESSAGES_DETAILS =
  '[messages] load processed messages details';
export const SET_LAST_MESSAGES_LOAD_DATE =
  '[messages] set the last date that was retrieved for messages';

export const loadAlertMessages = (greaterThanDate, lessThanDate) => ({
  type: LOAD_ALERT_MESSAGES,
  payload: {
    greaterThanDate,
    lessThanDate,
  },
});

export const refreshAlertMessages = (refreshDate) => ({
  type: REFRESH_ALERT_MESSAGES,
  payload: refreshDate,
});

export const processAlertMessages = () => ({
  type: PROCESS_ALERT_MESSAGES,
});
export const processCancellingMessage = () => ({
  type: PROCESS_CANCELLING_MESSAGE,
});

export const loadProcessedAlertMessages = (processedMessages) => ({
  type: LOAD_PROCESSED_ALERT_MESSAGES,
  payload: processedMessages,
});

export const messageError = (error) => ({
  type: MESSAGE_ERROR,
  payload: error,
});

export const loadMessageDetails = (message) => ({
  type: LOAD_MESSAGE_DETAILS,
  payload: message,
});
export const cancelMessage = (message) => ({
  type: CANCEL_MESSAGE,
  payload: message,
});
export const processMessageDetails = (message) => ({
  type: PROCESS_MESSAGE_DETAILS,
  payload: message,
});

export const updateMessage = (message) => ({
  type: UPDATE_MESSAGE,
  payload: message,
});
export const loadProcessedMessagesDetails = (processedMessages) => ({
  type: LOAD_PROCESSED_MESSAGES_DETAILS,
  payload: processedMessages,
});

export const setLastMessagesLoadDate = (date) => ({
  type: SET_LAST_MESSAGES_LOAD_DATE,
  payload: date,
});
